import { render } from "./ToRefs.vue?vue&type=template&id=f3c942fc"
import script from "./ToRefs.vue?vue&type=script&lang=ts"
export * from "./ToRefs.vue?vue&type=script&lang=ts"
script.render = render

export default script